export default __webpack_public_path__ + "static/media/nitin2.486d3c48.jpg";